import { EuiButtonIcon } from '@equipmentshare/ds2'
import { RefreshLineIcon } from 'components/icons'
import { RefreshButtonProps } from './types'
import useRefresh from './useRefresh'

import styles from './refresh.module.css'

export default function RefreshButtonEui( { refetchFunction }: RefreshButtonProps ) {
	const { isSpinning, onClick } = useRefresh( refetchFunction )

	const className = isSpinning ? styles.spinning : undefined

	return (
		<EuiButtonIcon
			className={className}
			color="text"
			iconType={RefreshLineIcon}
			aria-label="Refresh"
			onClick={onClick}
			size="m"
		/>
	)
}
